import { ComponentRef, forwardRef } from "react";
import { Typography, type TypographyProps } from "@mui/material";

const FlyoutHeaderTypography = forwardRef<
    ComponentRef<typeof Typography>,
    TypographyProps
>(
    ({ children, sx, ...props }, ref) => {
        const baseSx = {
            width: '100%',
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            hyphens: "auto",
            textAlign: { xs: "center", md: "left" },
            typography: "h4",
            marginBottom: 2,
        } as const;

        return (
            <Typography color="primary" ref={ref} {...props} sx={{ ...baseSx, ...sx }} >
                {children}
            </Typography>
        );
    }
);

FlyoutHeaderTypography.displayName = "FlyoutHeaderTypography";
export default FlyoutHeaderTypography;